module.exports = __webpack_public_path__ + "img/0-21.68d3e326.gif";